export default function({body}){
  return `
<div class="page">
  ${body}
</div>
  `
}
